//设置缓存
const set = (key, value)=> {
    localStorage.setItem(key, JSON.stringify(value));
}

//读取缓存
const get = (key)=> {
    return JSON.parse(localStorage.getItem(key));
}

//删除缓存
const remove = (key)=> {
    console.log('remove',key);
    localStorage.removeItem(key);
}

export const storage = {
    set,get,remove
}
